import 'jquery-ui';
import $ from 'jquery';

export const search = new function UserSearch() {
    this.searchFields = ['username', 'firstName', 'lastName', 'email', 'userProfileFieldValues.userProfileField.name'];

    this.searchObj = {
        query: [[]],
        limit: 20,
        offset: 0,
        sortOrders: [],
    };

    this.defaults = function(opts) {
        this.searchObj.query = opts.query || this.searchObj.query; //optional load startup query, default is blank for "all"
        this.searchObj.limit = opts.limit || this.searchObj.limit; //optional set return limit
        this.searchObj.offset = opts.offset || this.searchObj.offset; //optional set offset (starting point)
        this.searchObj.sortOrders = opts.sortOrders || this.searchObj.sortOrders;
    };

    this.buildSearchString = function(opts) {
        let queryParameters = [];
        const limit = this.searchObj.limit,
            offset = opts.pageIndex ? opts.pageIndex * this.searchObj.limit : this.searchObj.offset,
            sortOrders = this.searchObj.sortOrders;

        const searchValue = opts.$searchInput ? opts.$searchInput.val() : null;

        if (!$.isEmptyObject(this.searchObj.query[0])) {
            let queries = this.searchObj.query;
            const newQueries = [];
            $.each(queries, function(i, query) {
                const newQuery = [];
                $.each(query, function(j, q) {
                    if (q.field !== 'userRoles.role.id') {
                        newQuery.push(q);
                    }
                });
                newQueries.push(newQuery);
            });
            queries = this.searchObj.query = newQueries;

            if (opts.roleIds) {
                $.each(queries, function(i, query) {
                    query.push({
                        field: 'userRoles.role.id',
                        operation: 'IN',
                        value: opts.roleIds.split(','),
                    });
                });
            }
            queryParameters = queries;
        } else if (searchValue && searchValue.length > 0) {
            $.each(this.searchFields, function(i, field) {
                const query = [
                    {
                        field,
                        operation: 'LIKE',
                        value: searchValue,
                    },
                ];

                if (opts.roleIds) {
                    query.push({
                        field: 'userRoles.role.id',
                        operation: 'IN',
                        value: opts.roleIds.split(','),
                    });
                }
                queryParameters.push(query);
            });
        } else if (opts.roleIds) {
            queryParameters.push([
                {
                    field: 'userRoles.role.id',
                    operation: 'IN',
                    value: opts.roleIds.split(','),
                },
            ]);
        }

        opts.pagingParams = {
            offset,
        };

        return (
            'api/user/advanced-search?' +
            'queryParameters=' +
            JSON.stringify(queryParameters) +
            '&limit=' +
            limit +
            '&offset=' +
            offset +
            '&sortOrders=' +
            JSON.stringify(sortOrders)
        );
    };

    this.searchHandler = function() {
        const that = this.parent;
        that.userSearchHandler();
    };

    this.searchSelectorHandler = function(e, opts) {
        const $caller = $(e.currentTarget);
        const field = $caller.val();

        opts.$filterButton.addClass('active');
        opts.$searchButton.removeClass('active');

        opts.$operator.find('li.select-option').hide();
        const field2 = $('#search-fields').val();
        let _class = null;
        switch (field2) {
            case 'all':
            case 'username':
            case 'firstName':
            case 'lastName':
            case 'email':
                _class = '.non-date';
                break;
            default:
                _class = 'li.select-option';
                break;
        }

        $(_class).show();

        if ($caller.attr('id') !== 'search-operators') {
            $.each($(_class + ':not(.test)'), function(i, item) {
                const $item = $(item);
                const name = $item.attr('data-name');
                const value = $item.attr('data-value');
                opts.$operator
                    .find('.sda-select-selected')
                    .attr('data-value', value)
                    .attr('data-name', name)
                    .find('.thumb-name')
                    .html(name);
                return false;
            });
        }

        if (field === 'ISEMPTY' || field === 'ISNULL') {
            opts.$searchInput
                .hide()
                .parent()
                .addClass('isempty');
        } else {
            opts.$searchInput
                .show()
                .parent()
                .removeClass('isempty');
        }
    };

    this.addSearchFiltersHandler = function(opts) {
        const value = opts.value || opts.searchInput.val();
        const filterFieldVal = opts.default ? 'all' : opts.filterField.attr('data-value');
        const operatorVal = opts.default ? 'LIKE' : opts.operator.attr('data-value');
        const filterFieldDesc = opts.default ? 'any field' : opts.filterField.attr('data-name');
        const operatorDesc = opts.default ? 'contains' : opts.operator.attr('data-name');
        const queryBlock =
            '<div class="sda-query-block" data-field="' +
            filterFieldVal +
            '" data-operator="' +
            operatorVal +
            '" data-value="' +
            value +
            '">' +
            filterFieldDesc +
            ' ' +
            operatorDesc +
            ' <span class="sda-query">' +
            value +
            '</span> <a class="sda-remove-search-operator" href="#"> <i class="fa-times"></i></a></div>';
        let query;

        this.parent = opts.that;

        opts.searchInput.val('');

        if (value) {
            if (filterFieldVal === 'all') {
                if ($.isEmptyObject(this.searchObj.query[0])) {
                    query = [];
                    for (const filter in this.searchFields) {
                        query.push([
                            {
                                //or
                                field: this.searchFields[filter],
                                operation: operatorVal,
                                value,
                            },
                        ]);
                    }
                } else {
                    let newQuery = [];
                    query = this.searchObj.query;
                    for (const filter in this.searchFields) {
                        newQuery = {
                            field: this.searchFields[filter],
                            operation: operatorVal,
                            value,
                        };
                        for (const q in query) {
                            if (query[q][0].field === filter) {
                                query[q].push(newQuery);
                            }
                        }
                    }
                }
                this.searchObj.query = query;
                opts.queryContainer.append(queryBlock);
            } else {
                query = {
                    field: filterFieldVal,
                    operation: operatorVal,
                    value,
                };
                for (const q in this.searchObj.query) {
                    this.searchObj.query[q].push(query);
                }
                opts.queryContainer.append(queryBlock);
            }
            this.searchHandler();
        } else if ((operatorVal === 'ISEMPTY' || operatorVal === 'ISNULL') && !value) {
            query = {
                field: filterFieldVal,
                operation: operatorVal,
            };
            this.searchObj.query[0].push(query);
            opts.queryContainer.append(queryBlock);
            this.searchHandler();
        } else if (filterFieldVal === 'all' && !value) {
            this.searchObj.query = [[]];
            this.searchHandler();
        }
        $('#sda-advanced-search-clear').remove();
        opts.queryContainer.append(
            '<a id="sda-advanced-search-clear" class="sda-btn sda-clear-search-query" >clear all</a>',
        );
    };

    this.removeSearchOperatorHandler = function(e, opts) {
        const $caller = $(e.currentTarget);
        const $parent = $caller.parent();
        const query = this.searchObj.query;
        const data = $parent.data();
        let newQuery = [[]];

        for (const key in query[0]) {
            if (
                data.field === query[0][key].field &&
                data.operator === query[0][key].operation &&
                data.value === query[0][key].value
            ) {
                $parent.remove();
            } else if (data.operator === 'EQUALS') {
                $parent.remove();
            } else if (data.field === 'all') {
                for (const _key in query[0]) {
                    for (const q in query[_key]) {
                        if (!(query[_key][q].value === data.value && query[_key][q].operation === data.operator)) {
                            newQuery = [];
                            newQuery.push([query[_key][q]]);
                        }
                    }
                }
                $parent.remove();
            } else {
                newQuery[0].push(query[0][key]);
            }
        }

        if (opts.$queryContainer.length < 1) {
            opts.$filterButton.removeClass('active');
            opts.$searchButton.addClass('active');
        }
        $('.sda-query-block').each(function() {
            const $this = $(this);
            const {field, operator} = $this.data();
            if (field === data.field && operator === data.operator && $this.text() === $parent.text()) {
                $this.remove();
            }
        });
        if (!$('.sda-query-block').length) {
            $('#sda-advanced-search-clear').remove();
        }

        this.searchObj.query = newQuery;
        this.searchHandler();
    };

    this.clearSearch = function() {
        this.searchObj.query = [[]];
        $('.sda-search-query-container').empty();
        this.searchHandler();
    };
}();

export function collections(opts) {
    const deferred1 = $.Deferred(),
        deferred2 = $.Deferred();

    const result = $.when(deferred1, deferred2);

    const userUrl = search.buildSearchString(opts);

    opts.userCollection.getUsers(
        userUrl,
        opts.userCollection,
        function() {
            opts.userCollection.sort();
            deferred1.resolve();
            opts.that.renderSearchResult(opts);
        },
        function() {
            deferred1.reject();
        },
    );

    if (opts.roleCollection) {
        opts.roleCollection.getRoles(
            opts.roleCollection,
            function() {
                deferred2.resolve();
                opts.that.renderUserRoleFilter(opts);
            },
            function() {
                deferred1.reject();
            },
        );
    } else {
        deferred2.resolve();
    }

    return result;
}

export function comparatorSort(opts) {
    opts.collection.comparator = function(model) {
        return model.attributes[opts.sort];
    };

    if (opts.direction === 'asc') {
        opts.collection.sort();
    } else {
        opts.collection.sort({silent: true});
        opts.collection.models = opts.collection.models.reverse();
        opts.collection.trigger('reset', opts.collection, {});
    }
    opts.that.renderSearchResult(opts);
}
